export default "__VITE_ASSET__b028b104__$_?component__"